import React, { Component } from 'react'
import { PropTypes } from 'prop-types'
import { connect } from 'react-redux'
import {
  initResumeProcess,
  requireResumeOtpSms,
  sendResumeOtpSms,
  validateResumeOtp,
  authenticated
} from '../../state/actions/stepActions'
import Page from '../../components/page'
import Header from '../../components/header'
import Wrapper from '../../components/wrapper'
import Clearfix from '../../components/clearfix'
import Title from '../../components/title'
import Widgets from '../../components/widgets'
import Button from '../../components/button'
import Footer from '../../components/footer'
import Spinner from '../../components/spinner'
import Modal from '../../components/modal'
import AuthModal from '../../components/authmodal'
import Result from '../../components/result'
import {ios11Instructions} from '../../utils'
import { css, withStyles } from '../../styles/withStyles'
import Styles from './styles'
import { APIAlertPopup } from '../../components/apiAlertPopup';

class Resume extends Component {
  constructor(props) {
    super(props)
  }

  componentDidMount() {
    const { guid, dispatch, routing } = this.props
    dispatch(initResumeProcess(guid, routing.flow))
  }

  componentWillReceiveProps(nextProps) {
    const { components, dispatch } = this.props
    const { auth } = nextProps.step
    if (!!auth && !!auth.tokenId && !!nextProps.step.loginFormVisible) {
      dispatch(authenticated())
    }

    if (
      !!components &&
      !!components['CODICE_FISCALE-CF'] &&
      components['CODICE_FISCALE-CF'].validations &&
      components['CODICE_FISCALE-CF'].validations.url
    ) {
      delete components['CODICE_FISCALE-CF'].validations.url
    }
  }

  goBack() {
    const { dispatch, guid, routing } = this.props
    dispatch(initResumeProcess(guid, routing.flow))
    window.scrollTo(0, 0)
  }

  goForward() {
    const { dispatch, components, guid, routing } = this.props

    if (!!components['RESUME_BY_CELL-CODICE_CELLULARE']) {
      dispatch(validateResumeOtp(components['RESUME_BY_CELL-CODICE_CELLULARE'], routing.flow))
    } else {
      dispatch(requireResumeOtpSms(guid))
    }

    window.scrollTo(0, 0)
  }

  sendOtpSms() {
    const { dispatch, components } = this.props

    dispatch(
      sendResumeOtpSms(!components['RESUME_BY_CELL-GUID_PROCESSO'].value)
    )

    window.scrollTo(0, 0)
  }

  render() {
    let IOS11Rules=ios11Instructions()
    if (!this.globalStylesOverrides) {
      this.globalStylesOverrides = css(this.props.styles.globals)
    }

    if (this.props.step.isLoading) {
      return <Spinner type="global" />
    }

    if (this.props.step.hasServerErrors) {
      return (
        <Modal>
          <Result type="error">
            <div
              dangerouslySetInnerHTML={{
                __html: this.props.step.serverErrorMessage
              }}
            />
            <div dangerouslySetInnerHTML={{ __html:IOS11Rules}} />
          </Result>
        </Modal>
      )
    }

    return (
      <Page>
        {/*@hack for sella.it login*/}
        {!!this.props.widgets.LOGIN_SE_CLIENTE &&
        this.props.widgets.LOGIN_SE_CLIENTE.status.indexOf('hidden') < 0 ? (
          <AuthModal isCloseButtonHidden={true} />
        ) : (
          ''
        )}
        {this.props.step.isStepLoading ? <Spinner type="step" /> : ''}
        <Header
          centeredLogo={true}
          whiteLabel={
            !!this.props.routing.locationBeforeTransitions.query.embedded
          }
        />
        {
          this.props.step.isAPIResError==true?<APIAlertPopup />:''
          }
        <Wrapper>
          <Title
            title={
              !!this.props.guid
                ? 'Accedi alla tua richiesta'
                : 'Accedi alle tue richieste'
            }
            subtitle={
              !!this.props.guid
                ? 'Inserisci il codice ricevuto tramite SMS sul tuo numero di cellulare'
                : 'Inserisci i dati per accedere alla tua lista richieste.'
            }
          />

          <Widgets
            widgets={this.props.widgets}
            components={this.props.components}
            renderNegatives={true}
            guid={this.props.guid}
          />

          {!!this.props.components['RESUME_BY_CELL-CODICE_CELLULARE'] ? (
            <div>
              <p style={{ textAlign: 'center' }}>
                Il codice OTP (One Time Password) ti è stato inviato
                automaticamente sul tuo numero di cellulare, se non dovessi
                riceverlo entro un minuto puoi richiederne uno nuovo cliccando
                sul tasto "Reinvia OTP".
              </p>
            </div>
          ) : (
            ''
          )}

          {!!this.props.components['RESUME_BY_CELL-CODICE_CELLULARE'] ? (
            <Button
              text="Reinvia OTP"
              action={() => {
                this.sendOtpSms()
              }}
              pullTo="left"
            />
          ) : (
            ''
          )}

          {!!this.props.components &&
          Object.keys(this.props.components).length > 0 ? (
            <Button
              text="Continua"
              action={() => {
                this.goForward()
              }}
              type="primaryEnabled"
              pullTo="right"
            />
          ) : (
            ''
          )}
          <Clearfix />
        </Wrapper>
        <Footer />
      </Page>
    )
  }
}

Resume.propTypes = {
  guid: PropTypes.string,
  step: PropTypes.object.isRequired,
  widgets: PropTypes.object.isRequired,
  components: PropTypes.object.isRequired,
  dispatch: PropTypes.func.isRequired
}

const mapStateToProps = (state, ownProps) => {
  return {
    ...state,
    guid: ownProps.params.guid
  }
}

export default connect(mapStateToProps)(withStyles(Styles)(Resume))



// WEBPACK FOOTER //
// ./containers/resume/index.js